import { FeaturePlaygroundExperiment } from '~/landing_page/components/FeaturePlaygroundExperiment';

/**
 * FeatureSearchDemo — the web search interaction, and nothing else: a cursor comes in and presses
 * search, the bar zooms in, a query gets typed, on a loop. No text, no background. Same role as
 * FeatureAgentDemo, FeatureContextDemo, and FeaturePresentDemo. The feature section composes this
 * interaction together with the heading copy and the background image at the import site.
 */
export function FeatureSearchDemo() {
  return <FeaturePlaygroundExperiment />;
}

FeatureSearchDemo.displayName = 'FeatureSearchDemo';
